"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5267],{

/***/ 85267:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var client_icons_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88121);



/* harmony default export */ __webpack_exports__["default"] = ((0,client_icons_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
    d: "M21 2C20.4 2 20 2.4 20 3V9H18.9C18.4 6.7 16.4 5 14 5H7C4.2 5 2 7.2 2 10C2 11.8 3 13.6 4.4 14.6C5 15 5.6 15.2 6.3 15.2C6.7 15.2 7.1 15.1 7.5 15C7.8 14.9 8.2 14.7 9 13.8C9.9 12.9 11.5 12.9 12.3 13.8C13.1 14.6 13.5 14.9 13.8 15C14.8 15.4 15.9 15.3 16.8 14.6C17.9 13.8 18.8 12.5 19 11H20V16C20 18.2 18.2 20 16 20H13C12.2 20 11.8 19.5 11.7 19H12C12.6 19 13 18.6 13 18C13 17.4 12.6 17 12 17H10.5H10H9C8.4 17 8 17.4 8 18C8 18.6 8.4 19 9 19H9.6C9.9 20.8 11.2 22 13 22H16C19.3 22 22 19.3 22 16V3C22 2.4 21.6 2 21 2ZM15.5 12.9C14.9 13.3 14.5 13.1 14.4 13.1C14.4 13.1 14.2 13 13.6 12.4C12.8 11.5 11.7 11 10.5 11C9.3 11 8.2 11.5 7.4 12.4C6.9 13 6.6 13.1 6.6 13.1C6.5 13.2 6 13.3 5.4 12.9C4.6 12.4 4 11.1 4 10C4 8.3 5.3 7 7 7H14C15.7 7 17 8.3 17 10C17 11.1 16.4 12.4 15.5 12.9Z"
}), "ThingsToDo"));


/***/ })

}]);